import { render } from "./S127606.vue?vue&type=template&id=143fb4ec"
const script = {}
script.render = render

export default script